const TeacherFill = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.75 4.125V5.5h15.125v11H8.25v1.375h12.375V16.5H19.25V4.125H2.75Zm2.751 2.063a2.761 2.761 0 0 0-2.751 2.75 2.76 2.76 0 0 0 2.751 2.75 2.76 2.76 0 0 0 2.749-2.75 2.76 2.76 0 0 0-2.749-2.75Zm4.124.687V8.25h3.438V6.875H9.624Zm4.813 0V8.25H16.5V6.875h-2.063ZM5.5 7.563c.766 0 1.374.607 1.374 1.375 0 .77-.607 1.374-1.374 1.374-.77 0-1.376-.604-1.376-1.374 0-.768.607-1.376 1.376-1.376Zm4.124 2.062V11H16.5V9.625H9.625Zm-6.875 2.75v5.5h1.375V13.75h2.063v4.125h1.375v-3.673l1.419.751c.402.213.885.213 1.287 0v.002l2.426-1.284-.641-1.217-2.428 1.284-2.128-1.124a2.066 2.066 0 0 0-.964-.239H2.75Z"
        fill="#9C9C9C"
      />
    </svg>
  );
};

export default TeacherFill;
